import { paths } from '~/__generated__/botco-api-schema';
import { ExtractPathParamsFromPath } from '~/types/open-api-helpers';

import { axiosClient } from '../axiosClient';
import { AgentForm, Intent } from './types';

type PathUrl = paths['/agents/{agentId}/intents/{intentId}/connections']['get'];
type Response = {
  sourceForms: AgentForm[];
  sourceIntents: Intent[];
};
type Request = ExtractPathParamsFromPath<PathUrl>;

export const getAgentIntentConnections = ({ agentId, intentId }: Request) => {
  return axiosClient.get<Response>(
    `/agents/${agentId}/intents/${intentId}/connections`
  );
};
